'use strict';

angular.module('cimerFrontEndApp').controller('SurveyCtrl', ['$scope', 'SurveyService', '$location', 'Session','$uibModal',function ($scope, SurveyService, $location,Session,$uibModal) {

        if (!Session.getSessionObject().isAuthenticated) {
            $location.url('/');
            return;
        }

        $scope.errMsg = '';
        $scope.survey = [];
        $scope.disableButtons = false;
        $scope.surveyLoading = true;
        $scope.percentComplete = 0;
       
        //survey parameters will be delivered via the SurveyService
        var surveyLoadParams = SurveyService.getSurveyParameters();
        if (surveyLoadParams.hasOwnProperty('surveyID')) {
            $scope.surveyID = surveyLoadParams.surveyID;
            SurveyService.loadAssignedSurvey(surveyLoadParams).then(function(result) {
              
                $scope.survey = result.Survey;
                $scope.mentor = result.MentorName;
                $scope.mentee = result.MenteeName;
                $scope.name = result.Name;
                $scope.currentSectionIndex = 0;  // set the index of the current section of the survey to the first one
              
                //stop loading image after data loaded
                $scope.surveyLoading = false;


            }, function(err) {
                $scope.errMsg = 'Unable to load survey with ID '+surveyLoadParams.surveyID + '.  '+err;
                $scope.disableButtons = true;
                SurveyService.clearSurveyParameters();
            });
        }
        else {
            $scope.errMsg = 'No survey selected.';
            SurveyService.clearSurveyParameters();
        }

        $scope.submitSurvey = function() {
            $scope.disableButtons = true; //prevent multiple submission


            var finalizeSurveyModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'finalizeHeader',
                ariaDescribedBy: 'finalizeBody',
                templateUrl: 'finalizeSurveyModal.html',
                controller: 'FinalizeSurveyModalCtrl'
            });

            finalizeSurveyModalInstance.result.then(function () {
                SurveyService.submitSurvey($scope.survey, surveyLoadParams.assignedSurveyID).then(function () {
                    SurveyService.clearSurveyParameters();
                    $location.url('/mySurveys');
                }, function () {
                    $location.path('error');
                });
            }, function () {
                $scope.disableButtons = false;
            });
        };

        $scope.saveSurveyProgress = function () {
            $scope.disableButtons = true; //prevent multiple submission
            SurveyService.saveSurvey($scope.survey,surveyLoadParams.assignedSurveyID).then(function() {
                SurveyService.clearSurveyParameters();
                $location.url('/mySurveys');
            },function() {
                $location.path('error');
            });

        };

        $scope.next = function () {
            $scope.disableButtons = true; //prevent multiple submission
            $scope.errMsg = '';
            // verify all required questions have been answered
            var currentSection = $scope.survey.Sections[$scope.currentSectionIndex];
            for (var i = 0; i < currentSection.QuestionPrompts.length; i++) {
                var prompt = currentSection.QuestionPrompts[i];
                // matrix questions cannot be required so only check other questions
                if (!prompt.hasOwnProperty('QuestionPromptID')) {
                    if (prompt.Required) {
                        // Free text answers
                        if (prompt.QuestionTypeID === 3 && (!prompt.hasOwnProperty('AnswerText') || prompt.AnswerText === "")) {
                            $scope.disableButtons = false;
                            $scope.errMsg = "Please answer all required questions.";
                            return;
                        }
                        // single select
                        else if (prompt.QuestionTypeID === 1 && !prompt.hasOwnProperty('Answer')) {
                            $scope.disableButtons = false;
                            $scope.errMsg = "Please answer all required questions.";
                            return;
                        }
                        // multi select
                        else if (prompt.QuestionTypeID === 4) {
                            // no items selected
                            if (!prompt.hasOwnProperty('MultiSelectAnswers')) {
                                $scope.disableButtons = false;
                                $scope.errMsg = "Please answer all required questions.";
                                return;
                            }
                            else { // verify we have at least 1 checked item
                                var hasCheckedItem = false;
                                for (var key in prompt.MultiSelectAnswers) {
                                    if (prompt.MultiSelectAnswers[key].Checked) {
                                        hasCheckedItem = true;
                                        break;
                                    }
                                }
                                if (!hasCheckedItem) {
                                    $scope.disableButtons = false;
                                    $scope.errMsg = "Please answer all required questions.";
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            // save survey
            SurveyService.saveSurvey($scope.survey, surveyLoadParams.assignedSurveyID).then(function (result) {
                if (!result) {
                    $location.path('error');
                }
                if ($scope.currentSectionIndex !== $scope.survey.Sections.length - 1) {
                    for (var sectionIx = $scope.currentSectionIndex + 1; sectionIx < $scope.survey.Sections.length; sectionIx++) {
                        var section = $scope.survey.Sections[sectionIx]
                        $scope.percentComplete = Math.floor((section.sectionNumber / $scope.survey.totalNumberOfSections) * 100);
                        if (section.IsParentSection) { // if the next section is a parent section, we can automatically go to it without evaluating any logic
                            $scope.calculateQuestionNumbers(section);
                            $scope.currentSectionIndex = sectionIx;
                            break;
                        }
                        else { // section is child section, evaluate what questions to show
                            section = SurveyService.calculateCanShowChildSection(section, $scope.survey);
                            if (section.canShowSection) {
                                $scope.calculateQuestionNumbers(section);
                                $scope.currentSectionIndex = sectionIx;
                                break;
                            }
                        }
                    }
                }
                $scope.disableButtons = false;
            }, function () {
                $location.path('error');
            });
        }

        $scope.previous = function () {
            $scope.disableButtons = true; //prevent multiple submission
            SurveyService.saveSurvey($scope.survey, surveyLoadParams.assignedSurveyID).then(function (result) {
                if (!result) {
                    $location.path('error');
                }
                if ($scope.currentSectionIndex > 0) {
                    for (var sectionIx = $scope.currentSectionIndex - 1; sectionIx >= 0; sectionIx--) {
                        var section = $scope.survey.Sections[sectionIx]
                        $scope.percentComplete = Math.floor((section.sectionNumber / $scope.survey.totalNumberOfSections) * 100);
                        if (section.IsParentSection) { // if the previous section is a parent section, we can automatically go to it without evaluating any logic
                            $scope.currentSectionIndex = sectionIx;
                            break;
                        }
                        else { // section is child section, evaluate if it should be shown
                            if (section.canShowSection) {
                                $scope.currentSectionIndex = sectionIx;
                                break;
                            }
                        }
                    }
                }
                $scope.disableButtons = false;
            }, function () {
                $location.path('error');
            });
        }

        $scope.calculateQuestionNumbers = function (section) {
            // get the most recent question number from the previous section (still at currentSectionIndex because we haven't updated it yet)
            var previousSection = $scope.survey.Sections[$scope.currentSectionIndex];
            var questionCount;
            if (previousSection.IsParentSection) {
                questionCount = previousSection.QuestionPrompts[previousSection.QuestionPrompts.length - 1].questionCount;
            }
            else {  // if a child question, need to find the last child question that was shown and get the question number
                for (var i = 0; i < previousSection.QuestionPrompts.length; i++) {
                    if (previousSection.QuestionPrompts[i].canShowQuestion) {
                        questionCount = previousSection.QuestionPrompts[i].questionCount;
                    }
                }
            }
            // assign the question counts for this section
            for (var i = 0; i < section.QuestionPrompts.length; i++) {
                if (section.QuestionPrompts[i].canShowQuestion) {
                    questionCount++;
                    section.QuestionPrompts[i].questionCount = questionCount;
                }
            }
        }

}]);

angular.module('cimerFrontEndApp').controller('FinalizeSurveyModalCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.finalize = function () {
        $uibModalInstance.close();
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);

//Controller for testing survey builds
angular.module('cimerFrontEndApp').controller('TestSurveyCtrl', ['$scope', 'SurveyService', '$routeParams', function ($scope, SurveyService, $routeParams) {

    $scope.surveyID = $routeParams.id;
    SurveyService.getSurvey($scope.surveyID).then(function (result) {
        $scope.survey = result;
    });


}]);
